import { Box } from "@material-ui/core";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import routes from "./configs/routes";
import MainLayout from "./layout/MainLayout";
import { initReconnectWallet } from "./web3/wallet/event-handler/reconnect";


function App() {
  const { enqueueSnackbar: eq } = useSnackbar();
  const dp = useDispatch();
  useEffect(() => {
    initReconnectWallet(dp, eq);
  }, []);
  return (
    <Router basename="/leaderboard">
      <Switch>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            exact={route.exact}
            render={(props) => {
              const LayoutTag = MainLayout;

              return (
                <Suspense fallback={null}>
                  <LayoutTag>
                    <Box
                      className={clsx({
                        [`animate__animated animate__${route.animation}`]: Boolean(route.animation),
                      })}
                    >
                      <route.component {...props} />
                    </Box>
                  </LayoutTag>
                </Suspense>
              );
            }}
          />
        ))}
        <Route path="/">
          <Redirect to="/statistic" />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
